import React from 'react';
import { useSearchParams } from 'react-router';

import { Button } from '@/components/ui/button';
import { CustomerTable } from '@/sections/customerManagement/components/CustomerTable';

export const BugBountyDashboard: React.FC = () => {
  const [, setSearchParams] = useSearchParams();

  return (
    <CustomerTable
      customerFilter={{ includeTypes: ['BUG_BOUNTY'] }}
      addButtonLabel="Add Specific Bug Bounty Program"
      defaultCustomerType="BUG_BOUNTY"
      emptyStateTitle="No bug bounty programs found"
      headerActions={
        <Button
          size="sm"
          variant="outline"
          onClick={() => setSearchParams({ view: 'discover-programs' })}
        >
          Discover Programs
        </Button>
      }
    />
  );
};
